<style scoped>
    .close {
        font-size: 2.0em;
    }
</style>

<template>

    <div>
        <div id="content-modal" class="modal fade invites-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ title }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <component :is="bodyComponent" v-bind="bodyComponentProps" v-on="bodyComponentEvents"></component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CreateCodeForm from './CreateCodeForm'
    import EditCodeForm from './EditCodeForm'
    import Invites from './Invites'
    import CreateInviteForm from './CreateInviteForm'
    import PreviewInvite from './PreviewInvite'
    import ConfirmModal from './ConfirmModal.vue'
    import { mapWritableState, mapActions } from 'pinia';
    import { useRegistrationCodesStore } from './store.js';

    export default {
        components: {
            CreateCodeForm,
            EditCodeForm,
            Invites,
            CreateInviteForm,
            PreviewInvite,
            ConfirmModal,
        },
        props: [
            'user-role', 
            'user-name', 
            'user-email'
        ],
        data() {
            return {
                partners: [],
                consultants: [],
                refreshInvites: false,
                previewInviteId: null,
            };
        },
        methods: {
            codeCreatedListener() {
                this.closeModal();
            },
            confirmCodeDeleteListener(payload) {
                this.bodyComponent = 'ConfirmModal';
                this.title = "Confirm Delete";
            },
            openInvites(code){
                this.selectedCode = code
            }, 
            inviteCreatedListener(payload) {
                this.bodyComponent = 'PreviewInvite';
                this.title = 'Preview Invite';
                this.previewInviteId = payload.inviteCreatedId
            },
            inviteSentListener() {
                this.bodyComponent = 'Invites';
                this.invite = {}
                this.title = `Invites for code ${this.selectedCode.code}`;
                this.refreshInvites = true
            },
            inviteDeletedListener() {
                this.closeModal();
            },
            getCodes(params = {}) {
                var url = '/api/registration-codes'
                var partnerId = new URL(window.location).searchParams.get("partner_id")
                let query = params;
                let queryString = '';
                var queryDict = {};
                location.search
                    .substr(1)
                    .split("&")
                    .forEach((item) => {
                        queryDict[item.split("=")[0]] = item.split("=")[1]
                    });
                if(queryDict.hasOwnProperty('partner_id')){
                    var partnerId = queryDict.partner_id;
                } else {
                    var partnerId = null;
                }
                if(partnerId){
                    query.partner_id = partnerId
                }
                if (Object.keys(query).length > 0) {
                    queryString = '?'+Object.keys(query).map(key => key + '=' + query[key]).join('&');
                }
                console.log(queryString);
                return axios.get(url+queryString)
                    .then((response) => {
                        this.loading = false
                        this.codes = response.data.data
                        this.totalRows = this.codes.length
                        return response
                    })
                    .catch(function (error) {
                        return error
                    })
            },
            deleteCode() {
                axios.delete('/api/registration-codes/'+ this.selectedCode.id)
                .then(function (response) {
                    this.closeModal();
                }.bind(this))
                .catch(function (error) {
                    console.error(error)
                })
            },
            getPartners() {
                axios.get('/api/partners')
                .then(function (response) {
                    this.partners = response.data.data
                }.bind(this))
                .catch(function (error) {
                    console.error(error)
                })
            },
            getConsultants() {
                axios.get('/api/consultants')
                .then(function (response) {
                    this.consultants = response.data.data
                }.bind(this))
                .catch(function (error) {
                    console.error(error)
                })
            },
            closeModal() {
                const modal = document.getElementById("content-modal");
                modal.classList.remove('show');
                modal.style.display = 'none';
                modal.setAttribute('aria-hidden', 'true');
                const modalBackdrop = document.querySelector('.modal-backdrop');
                if (modalBackdrop) {
                    modalBackdrop.remove();
                }
                document.body.classList.remove('modal-open');
            },
            confirmDelete() {
                this.deleteCode();
                this.refreshCodes = !this.refreshCodes;
            }
        },
        computed: {
            partner_options: function () {
                let options = [];
                for (var i = 0; i < this.partners.length; i++) {
                    options.push({'value':this.partners[i].id, 'text': this.partners[i].name})
                }
                return options
            },
            consultant_options: function () {
                let options = [];
                for (var i = 0; i < this.consultants.length; i++) {
                    options.push({'value':this.consultants[i].id, 'text': this.consultants[i].name})
                }
                return options
            },
            admin_to_partner: function () {
                if (this.userRole == 'site-admin' && this.invite.to_role == 'partner-user') {
                    return true
                }
                return false
            },
            sortCodeOptions: function () {
                if (this.codeFields) {
                    return this.codeFields
                        .filter(f => f.sortable)
                        .map(f => { return { text: f.label, value: f.key } })
                }
                return new Array();
            },
            filteredCodes: function() {
                if (this.showDisabled) {
                    return this.codes;
                } else {
                    return this.codes.filter(code => code.status === 'Enabled');
                }
            },
            bodyComponentProps: function() {
                let props = null;

                switch(this.bodyComponent) {
                    case 'CreateCodeForm':
                        props = {
                            partners: this.partners,
                            consultants: this.consultants
                        };
                        break;
                    case 'EditCodeForm':
                        props = {
                            partners: this.partners,
                            consultants: this.consultants,
                            value: this.selectedCode
                        };
                        break;
                    case 'Invites':
                        props = {
                            'registration-code': this.selectedCode,
                            'refresh-invites': this.refreshInvites,
                        };
                        break;
                    case 'CreateInviteForm':
                        props = {
                            code: this.selectedCode,
                        };
                        break;
                    case 'PreviewInvite':
                        props = {
                            'user-role': this.userRole,
                            'user-email': this.userEmail,
                            'user-name': this.userName,
                            previewInviteId: this.previewInviteId
                        };
                        break;
                    case 'ConfirmModal':
                        props = {

                        }
                        break;
                    default:
                        props = {};
                        break;
                }
                return props;
            },
            bodyComponentEvents: function() {
                let events = null;
                switch(this.bodyComponent) {
                    case 'CreateCodeForm':
                        events = {
                            codeCreated: this.codeCreatedListener
                        }
                        break;
                    case 'EditCodeForm':
                        events = {
                            confirmCodeDelete: this.confirmCodeDeleteListener,
                        }
                        break;
                    case 'CreateInviteForm':
                        events = {
                            inviteCreated: this.inviteCreatedListener,
                        };
                        break;
                    case 'PreviewInvite':
                        events = {
                            inviteDeleted: this.inviteDeletedListener
                        };
                        break;
                    case 'ConfirmModal':
                        events = {
                            confirmDelete: this.confirmDelete
                        };
                        break;
                    default:
                        events = {};
                        break;
                }
                return events;
            },
            store: function() {
                return useRegistrationCodesStore();
            },
            ...mapWritableState(useRegistrationCodesStore, [
                'selectedCode',
                'bodyComponent',
                'title',
                'refreshCodes',
            ]),
        },
        watch: {
            /** Trigger refresh of codes list */
            "store.showModal"(newVal, oldVal) {
                if(!newVal)  {
                    this.closeModal();
                }
            },
        },
        mounted() {
            this.getPartners();    
            this.getConsultants();
        }
    }
</script>
